import { CommonModule } from '@angular/common'
import {
  Component,
  input,
} from '@angular/core'
import { FlexLayoutModule } from '@angular/flex-layout'
import { MatIconModule } from '@angular/material/icon'
import { MatTooltipModule } from '@angular/material/tooltip'
import { TranslateModule } from '@ngx-translate/core'

@Component({
  selector: 'mmx-eligibility-status',
  styleUrls: ['./eligibility-status.component.scss'],
  templateUrl: './eligibility-status.component.html',
  standalone: true,
  imports: [
    CommonModule,
    FlexLayoutModule,
    MatIconModule,
    MatTooltipModule,
    TranslateModule,
  ],
})
export class EligibilityStatusComponent {

  tooltip = input('')
  layoutGap = input('4px')
  status = input.required()
  icon = input.required()
  color = input.required()
  alternativeInsuranceName = input('')

  constructor() { }
}
